<div class="container-fluid component-background login-page" style="margin: 0; padding: 0">
  <div class="row" style="width: 100%">
    <div class="col-md-4">
      <!--LOGIN-->

      <div class="form-wrapper">
        <form
          class="form styled-form login-form"
          role="form"
          (ngSubmit)="login()"
          [formGroup]="loginForm"
        >
          <div class="mb-4">
            <p class="login-title mb-3" [translate]="'login.messages.loginTitle'">Dobrodosli</p>
            <p class="login-detail" [translate]="'login.messages.loginDetail'">
              Ulogujte se kako bi koristili BeneFit
            </p>
          </div>
          <div
            class="sign-in-error"
            *ngIf="authenticationError"
            [innerHtml]="'login.messages.error.authentication' | translate"
          >
            <strong>Failed to sign in!</strong> Please check your credentials and try again.
          </div>
          <mat-form-field>
            <mat-label [translate]="'global.form.username.placeholder'">Username</mat-label>
            <!-- (blur)="getLocationsForEmail()" : This should go to input below but comment out for now -->
            <input
              matInput
              name="username"
              id="username"
              class="form-control"
              formControlName="username"
              #username
              autocomplete="off"
              (blur)="getLocationsForEmail()"
            />
          </mat-form-field>

          <mat-form-field>
            <mat-label [translate]="'login.form.password.placeholder'">Password</mat-label>
            <!-- (focusout)="getLocationsForEmail()" : This should go to input below but comment out for now -->
            <input
              matInput
              name="password"
              id="password"
              class="form-control"
              [type]="hide ? 'password' : 'text'"
              formControlName="password"
              #password
              autocomplete="off"
            />
            <mat-icon matSuffix (click)="hide = !hide">{{
              hide ? 'visibility' : 'visibility_off'
            }}</mat-icon>
          </mat-form-field>

          <mat-form-field *ngIf="hasLocations">
            <mat-label [translate]="'login.form.location'">Location</mat-label>

            <mat-select matSelect name="location" formControlName="location" #location>
              <mat-option *ngFor="let loc of safeLocations" [value]="loc.id">
                {{ loc.location_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <a
            class="forget-password"
            (click)="requestResetPassword()"
            [translate]="'login.password.forgot'"
            >Did you forget your password?</a
          >
          <!-- <div class="login-fields-wrapper">
          </div> -->
          <div class="flow column">
            <button type="submit" mat-flat-button>
              <span [translate]="'login.form.button'">Sign in</span>
            </button>
            <button type="button" class="secondary black" mat-stroked-button (click)="register()">
              <span [translate]="'login.form.register'">Register</span>
            </button>
          </div>
        </form>

        <!-- <div class="mt-3 alert alert-warning">
				<a class="alert-link" (click)="requestResetPassword()" [translate]="login.password.forgot">Did you forget your password?</a>
		</div> -->
      </div>
    </div>
    <div class="col-md-8 logo-wrapper">
      <div class="button-div">
        <input
          type="radio"
          id="srb-lang"
          name="language-group"
          class="language-button"
          autocomplete="off"
          (click)="changeLanguage('sr')"
          [checked]="this.localStorageService.retrieve('locale') == 'sr' ? true : false"
        />
        <label class="language-label" for="srb-lang">SR</label>
        <input
          type="radio"
          id="eng-lang"
          name="language-group"
          class="language-button"
          autocomplete="off"
          (click)="changeLanguage('en')"
          [checked]="this.localStorageService.retrieve('locale') == 'en' ? true : false"
        />
        <label class="language-label" for="eng-lang">EN</label>
      </div>

      <img src="assets/images/Logo.png" alt="BeneFit logo" />
    </div>
    <!-- <div class="col-md-1 button-div">
			<button>SR</button>
			<button>EN</button>
		</div> -->
  </div>
</div>

<!-- <input [(ngModel)]="requestParam.key"> <button (click)="onClickFunction($event)">Click me</button> -->
